// extracted by mini-css-extract-plugin
export default {"card":"AC13CuCO","card_primary":"eSTl8bne","card_light":"r_WHmzpx","card_pale_primary":"jJnM8M28","card_pale_gray":"Q0jhjQRM"};